/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { DataConnectionHexVersionLinkMpFragmentDoc } from "../../../../hex-version-multiplayer/HexVersionMPModel.generated";
import { AgentChatMessageFragmentDoc } from "../../hex-project-shared/messages/AgentChatMessage.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ExistingAskThreadForNewMessagesFragment = {
  readonly __typename: "AgentChatThread";
  readonly id: c.AgentChatThreadId;
  readonly title: string | null;
  readonly status: Types.AgentChatThreadStatus;
};

export type AgentAskChatUpdatedThreadFragment = {
  readonly __typename: "AgentChatUpdatedThread";
  readonly id: c.AgentChatThreadId;
  readonly status: Types.AgentChatThreadStatus;
  readonly title: string | null;
};

export type ThreadForRetryFragment = {
  readonly __typename: "AgentChatThread";
  readonly id: c.AgentChatThreadId;
};

export type AskAgentThreadFragment = {
  readonly __typename: "AgentChatThread";
  readonly id: c.AgentChatThreadId;
  readonly title: string | null;
  readonly createdDate: c.DateTimeString;
  readonly revision: number;
  readonly messageCount: number;
  readonly status: Types.AgentChatThreadStatus;
  readonly type: Types.AgentChatThreadType;
  readonly hex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly title: string;
    readonly canShare: boolean;
    readonly currentDraft: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly dataConnectionHexVersionLinks: ReadonlyArray<{
        readonly __typename: "DataConnectionHexVersionLink";
        readonly id: c.DataConnectionHexVersionLinkId;
        readonly createdDate: c.DateTimeString;
        readonly updatedDate: c.DateTimeString;
        readonly deletedDate: c.DateTimeString | null;
        readonly revision: number;
        readonly dataConnectionId: c.DataConnectionId;
        readonly dataConnectionLinkType: Types.DataConnectionLinkType;
      }>;
    };
  } | null;
  readonly user: { readonly __typename: "User"; readonly id: c.UserId };
  readonly agentMessages: {
    readonly __typename: "AgentChatMessageConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AgentChatMessageEdge";
      readonly node: {
        readonly __typename: "AgentChatMessage";
        readonly id: c.AgentChatMessageId;
        readonly role: Types.MessageRole;
        readonly staticId: c.StaticAgentChatMessageId;
        readonly revision: number;
        readonly content: ReadonlyArray<c.MessageContentBlock | null>;
        readonly createdDate: c.DateTimeString;
        readonly agentChatThreadId: c.AgentChatThreadId;
        readonly runId: c.AgentChatRunId;
        readonly debugInfo: c.AgentChatMessageDebugInfo | null;
        readonly invokedByThreadId: c.AgentChatThreadId | null;
      };
    }>;
  };
};

export type AskUserMessageFragment = {
  readonly __typename: "AgentChatMessage";
  readonly id: c.AgentChatMessageId;
  readonly createdDate: c.DateTimeString;
  readonly content: ReadonlyArray<c.MessageContentBlock | null>;
};

export type AskAgentRecentThreadFragment = {
  readonly __typename: "AgentChatThread";
  readonly id: c.AgentChatThreadId;
  readonly title: string | null;
  readonly createdDate: c.DateTimeString;
  readonly revision: number;
  readonly messageCount: number;
  readonly hex: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
    readonly title: string;
    readonly trashDate: c.DateTimeString | null;
  } | null;
  readonly user: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly email: string;
    readonly name: string | null;
  };
  readonly latestUserMessage: {
    readonly __typename: "AgentChatMessage";
    readonly id: c.AgentChatMessageId;
    readonly createdDate: c.DateTimeString;
    readonly content: ReadonlyArray<c.MessageContentBlock | null>;
  } | null;
};

export type GetRecentThreadsQueryVariables = Types.Exact<{
  first: Types.Scalars["Int"]["input"];
  threadType: Types.AgentChatThreadType;
}>;

export type GetRecentThreadsQuery = {
  readonly __typename: "Query";
  readonly agentChatThreadsConnection: {
    readonly __typename: "AgentChatThreadConnection";
    readonly edges: ReadonlyArray<{
      readonly __typename: "AgentChatThreadEdge";
      readonly node: {
        readonly __typename: "AgentChatThread";
        readonly id: c.AgentChatThreadId;
        readonly title: string | null;
        readonly createdDate: c.DateTimeString;
        readonly revision: number;
        readonly messageCount: number;
        readonly hex: {
          readonly __typename: "Hex";
          readonly id: c.HexId;
          readonly title: string;
          readonly trashDate: c.DateTimeString | null;
        } | null;
        readonly user: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly email: string;
          readonly name: string | null;
        };
        readonly latestUserMessage: {
          readonly __typename: "AgentChatMessage";
          readonly id: c.AgentChatMessageId;
          readonly createdDate: c.DateTimeString;
          readonly content: ReadonlyArray<c.MessageContentBlock | null>;
        } | null;
      };
    }>;
  };
};

export type AgentChatUpdatedThreadByIdSubscriptionVariables = Types.Exact<{
  id: Types.Scalars["AgentChatThreadId"]["input"];
}>;

export type AgentChatUpdatedThreadByIdSubscription = {
  readonly __typename: "Subscription";
  readonly agentChatUpdatedThreadById: {
    readonly __typename: "AgentChatUpdatedThread";
    readonly id: c.AgentChatThreadId;
    readonly status: Types.AgentChatThreadStatus;
    readonly title: string | null;
  };
};

export type AgentChatMessagesByThreadIdSubscriptionVariables = Types.Exact<{
  id: Types.Scalars["AgentChatThreadId"]["input"];
}>;

export type AgentChatMessagesByThreadIdSubscription = {
  readonly __typename: "Subscription";
  readonly agentChatMessagesByThreadId: {
    readonly __typename: "AgentChatMessage";
    readonly id: c.AgentChatMessageId;
    readonly role: Types.MessageRole;
    readonly staticId: c.StaticAgentChatMessageId;
    readonly revision: number;
    readonly content: ReadonlyArray<c.MessageContentBlock | null>;
    readonly createdDate: c.DateTimeString;
    readonly agentChatThreadId: c.AgentChatThreadId;
    readonly runId: c.AgentChatRunId;
    readonly debugInfo: c.AgentChatMessageDebugInfo | null;
    readonly invokedByThreadId: c.AgentChatThreadId | null;
  };
};

export type AgentChatThreadByIdQueryVariables = Types.Exact<{
  id: Types.Scalars["AgentChatThreadId"]["input"];
}>;

export type AgentChatThreadByIdQuery = {
  readonly __typename: "Query";
  readonly agentChatThread: {
    readonly __typename: "AgentChatThread";
    readonly id: c.AgentChatThreadId;
    readonly title: string | null;
    readonly createdDate: c.DateTimeString;
    readonly revision: number;
    readonly messageCount: number;
    readonly status: Types.AgentChatThreadStatus;
    readonly type: Types.AgentChatThreadType;
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly title: string;
      readonly canShare: boolean;
      readonly currentDraft: {
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
        readonly dataConnectionHexVersionLinks: ReadonlyArray<{
          readonly __typename: "DataConnectionHexVersionLink";
          readonly id: c.DataConnectionHexVersionLinkId;
          readonly createdDate: c.DateTimeString;
          readonly updatedDate: c.DateTimeString;
          readonly deletedDate: c.DateTimeString | null;
          readonly revision: number;
          readonly dataConnectionId: c.DataConnectionId;
          readonly dataConnectionLinkType: Types.DataConnectionLinkType;
        }>;
      };
    } | null;
    readonly user: { readonly __typename: "User"; readonly id: c.UserId };
    readonly agentMessages: {
      readonly __typename: "AgentChatMessageConnection";
      readonly edges: ReadonlyArray<{
        readonly __typename: "AgentChatMessageEdge";
        readonly node: {
          readonly __typename: "AgentChatMessage";
          readonly id: c.AgentChatMessageId;
          readonly role: Types.MessageRole;
          readonly staticId: c.StaticAgentChatMessageId;
          readonly revision: number;
          readonly content: ReadonlyArray<c.MessageContentBlock | null>;
          readonly createdDate: c.DateTimeString;
          readonly agentChatThreadId: c.AgentChatThreadId;
          readonly runId: c.AgentChatRunId;
          readonly debugInfo: c.AgentChatMessageDebugInfo | null;
          readonly invokedByThreadId: c.AgentChatThreadId | null;
        };
      }>;
    };
  } | null;
};

export const ExistingAskThreadForNewMessagesFragmentDoc = /*#__PURE__*/ gql`
  fragment ExistingAskThreadForNewMessages on AgentChatThread {
    id
    title
    status
  }
`;
export const AgentAskChatUpdatedThreadFragmentDoc = /*#__PURE__*/ gql`
  fragment AgentAskChatUpdatedThread on AgentChatUpdatedThread {
    id
    status
    title
  }
`;
export const ThreadForRetryFragmentDoc = /*#__PURE__*/ gql`
  fragment ThreadForRetry on AgentChatThread {
    id
  }
`;
export const AskAgentThreadFragmentDoc = /*#__PURE__*/ gql`
  fragment AskAgentThread on AgentChatThread {
    id
    title
    createdDate
    revision
    messageCount
    hex {
      id
      title
      canShare
      currentDraft {
        id
        dataConnectionHexVersionLinks {
          id
          ...DataConnectionHexVersionLinkMPFragment
        }
      }
    }
    status
    type
    user {
      id
    }
    agentMessages {
      edges {
        node {
          ...AgentChatMessageFragment
        }
      }
    }
  }
  ${DataConnectionHexVersionLinkMpFragmentDoc}
  ${AgentChatMessageFragmentDoc}
`;
export const AskUserMessageFragmentDoc = /*#__PURE__*/ gql`
  fragment AskUserMessage on AgentChatMessage {
    id
    createdDate
    content
  }
`;
export const AskAgentRecentThreadFragmentDoc = /*#__PURE__*/ gql`
  fragment AskAgentRecentThread on AgentChatThread {
    id
    title
    createdDate
    revision
    messageCount
    hex {
      id
      title
      trashDate
    }
    user {
      id
      email
      name
    }
    latestUserMessage {
      ...AskUserMessage
    }
  }
  ${AskUserMessageFragmentDoc}
`;
export const GetRecentThreadsDocument = /*#__PURE__*/ gql`
  query GetRecentThreads($first: Int!, $threadType: AgentChatThreadType!) {
    agentChatThreadsConnection(first: $first, threadType: $threadType) {
      edges {
        node {
          id
          ...AskAgentRecentThread
        }
      }
    }
  }
  ${AskAgentRecentThreadFragmentDoc}
`;

/**
 * __useGetRecentThreadsQuery__
 *
 * To run a query within a React component, call `useGetRecentThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentThreadsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      threadType: // value for 'threadType'
 *   },
 * });
 */
export function useGetRecentThreadsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetRecentThreadsQuery,
    GetRecentThreadsQueryVariables
  > &
    (
      | { variables: GetRecentThreadsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRecentThreadsQuery, GetRecentThreadsQueryVariables>(
    GetRecentThreadsDocument,
    options,
  );
}
export function useGetRecentThreadsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRecentThreadsQuery,
    GetRecentThreadsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRecentThreadsQuery,
    GetRecentThreadsQueryVariables
  >(GetRecentThreadsDocument, options);
}
export function useGetRecentThreadsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRecentThreadsQuery,
    GetRecentThreadsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetRecentThreadsQuery,
    GetRecentThreadsQueryVariables
  >(GetRecentThreadsDocument, options);
}
export type GetRecentThreadsQueryHookResult = ReturnType<
  typeof useGetRecentThreadsQuery
>;
export type GetRecentThreadsLazyQueryHookResult = ReturnType<
  typeof useGetRecentThreadsLazyQuery
>;
export type GetRecentThreadsSuspenseQueryHookResult = ReturnType<
  typeof useGetRecentThreadsSuspenseQuery
>;
export type GetRecentThreadsQueryResult = Apollo.QueryResult<
  GetRecentThreadsQuery,
  GetRecentThreadsQueryVariables
>;
export const AgentChatUpdatedThreadByIdDocument = /*#__PURE__*/ gql`
  subscription AgentChatUpdatedThreadById($id: AgentChatThreadId!) {
    agentChatUpdatedThreadById(id: $id, threadType: ASK) {
      ...AgentAskChatUpdatedThread
    }
  }
  ${AgentAskChatUpdatedThreadFragmentDoc}
`;

/**
 * __useAgentChatUpdatedThreadByIdSubscription__
 *
 * To run a query within a React component, call `useAgentChatUpdatedThreadByIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentChatUpdatedThreadByIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChatUpdatedThreadByIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentChatUpdatedThreadByIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AgentChatUpdatedThreadByIdSubscription,
    AgentChatUpdatedThreadByIdSubscriptionVariables
  > &
    (
      | {
          variables: AgentChatUpdatedThreadByIdSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AgentChatUpdatedThreadByIdSubscription,
    AgentChatUpdatedThreadByIdSubscriptionVariables
  >(AgentChatUpdatedThreadByIdDocument, options);
}
export type AgentChatUpdatedThreadByIdSubscriptionHookResult = ReturnType<
  typeof useAgentChatUpdatedThreadByIdSubscription
>;
export type AgentChatUpdatedThreadByIdSubscriptionResult =
  Apollo.SubscriptionResult<AgentChatUpdatedThreadByIdSubscription>;
export const AgentChatMessagesByThreadIdDocument = /*#__PURE__*/ gql`
  subscription AgentChatMessagesByThreadId($id: AgentChatThreadId!) {
    agentChatMessagesByThreadId(id: $id, threadType: ASK) {
      ...AgentChatMessageFragment
    }
  }
  ${AgentChatMessageFragmentDoc}
`;

/**
 * __useAgentChatMessagesByThreadIdSubscription__
 *
 * To run a query within a React component, call `useAgentChatMessagesByThreadIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAgentChatMessagesByThreadIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChatMessagesByThreadIdSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentChatMessagesByThreadIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AgentChatMessagesByThreadIdSubscription,
    AgentChatMessagesByThreadIdSubscriptionVariables
  > &
    (
      | {
          variables: AgentChatMessagesByThreadIdSubscriptionVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AgentChatMessagesByThreadIdSubscription,
    AgentChatMessagesByThreadIdSubscriptionVariables
  >(AgentChatMessagesByThreadIdDocument, options);
}
export type AgentChatMessagesByThreadIdSubscriptionHookResult = ReturnType<
  typeof useAgentChatMessagesByThreadIdSubscription
>;
export type AgentChatMessagesByThreadIdSubscriptionResult =
  Apollo.SubscriptionResult<AgentChatMessagesByThreadIdSubscription>;
export const AgentChatThreadByIdDocument = /*#__PURE__*/ gql`
  query AgentChatThreadById($id: AgentChatThreadId!) {
    agentChatThread(id: $id) {
      ...AskAgentThread
    }
  }
  ${AskAgentThreadFragmentDoc}
`;

/**
 * __useAgentChatThreadByIdQuery__
 *
 * To run a query within a React component, call `useAgentChatThreadByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentChatThreadByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentChatThreadByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgentChatThreadByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    AgentChatThreadByIdQuery,
    AgentChatThreadByIdQueryVariables
  > &
    (
      | { variables: AgentChatThreadByIdQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AgentChatThreadByIdQuery,
    AgentChatThreadByIdQueryVariables
  >(AgentChatThreadByIdDocument, options);
}
export function useAgentChatThreadByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AgentChatThreadByIdQuery,
    AgentChatThreadByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AgentChatThreadByIdQuery,
    AgentChatThreadByIdQueryVariables
  >(AgentChatThreadByIdDocument, options);
}
export function useAgentChatThreadByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AgentChatThreadByIdQuery,
    AgentChatThreadByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    AgentChatThreadByIdQuery,
    AgentChatThreadByIdQueryVariables
  >(AgentChatThreadByIdDocument, options);
}
export type AgentChatThreadByIdQueryHookResult = ReturnType<
  typeof useAgentChatThreadByIdQuery
>;
export type AgentChatThreadByIdLazyQueryHookResult = ReturnType<
  typeof useAgentChatThreadByIdLazyQuery
>;
export type AgentChatThreadByIdSuspenseQueryHookResult = ReturnType<
  typeof useAgentChatThreadByIdSuspenseQuery
>;
export type AgentChatThreadByIdQueryResult = Apollo.QueryResult<
  AgentChatThreadByIdQuery,
  AgentChatThreadByIdQueryVariables
>;
